// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.behind__MathFloater-module--nMFuy,
.front__MathFloater-module--hRVMx {
    position: absolute;
}

.behind__MathFloater-module--nMFuy {
    z-index: 1;
}

.front__MathFloater-module--hRVMx {
    z-index: 3;
}

.float__MathFloater-module--nPMNa {
    animation-name: float__MathFloater-module--nPMNa;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
}

@keyframes float__MathFloater-module--nPMNa {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(calc(var(--px) * -10));
    }
}

.tile__MathFloater-module--xPuQ4 {
    display: flex;
    align-items: center;
    justify-content: center;
    border: calc(var(--px) * 1.5) solid var(--color-neutral-900);
    font-weight: 800;
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/MathFloater.module.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gDAAqB;IACrB,sCAAsC;IACtC,mCAAmC;AACvC;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4DAA4D;IAC5D,gBAAgB;AACpB","sourcesContent":[".behind,\n.front {\n    position: absolute;\n}\n\n.behind {\n    z-index: 1;\n}\n\n.front {\n    z-index: 3;\n}\n\n.float {\n    animation-name: float;\n    animation-timing-function: ease-in-out;\n    animation-iteration-count: infinite;\n}\n\n@keyframes float {\n    0%, 100% {\n        transform: translateY(0);\n    }\n    50% {\n        transform: translateY(calc(var(--px) * -10));\n    }\n}\n\n.tile {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: calc(var(--px) * 1.5) solid var(--color-neutral-900);\n    font-weight: 800;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"behind": `behind__MathFloater-module--nMFuy`,
	"front": `front__MathFloater-module--hRVMx`,
	"float": `float__MathFloater-module--nPMNa`,
	"tile": `tile__MathFloater-module--xPuQ4`
};
export default ___CSS_LOADER_EXPORT___;
